import axios from "axios";

export const inviaEmailRecuperoPasswordApi = (user) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/utente/password/mail/", user);
};